// SEARCH ARTICLES
export const SEARCH_ARTICLES = 'state.actions.search-articles.SEARCH_ARTICLES' as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SearchArticlesPayload = Record<any, any>;

export type SearchArticlesAction = {
	type: typeof SEARCH_ARTICLES;
	payload: SearchArticlesPayload;
};

export const searchArticles = (payload: SearchArticlesPayload): SearchArticlesAction => ({
	type: SEARCH_ARTICLES,
	payload,
});
